import {Tooltip} from "@material-ui/core"
import {withStyles} from "@material-ui/core/styles"

const LargeTooltip = withStyles(() => ({
	tooltip: {fontSize: 20},
}))(Tooltip)

export {LargeTooltip}
